import { render } from "./EntityOverview.vue?vue&type=template&id=2d010997"
import script from "./EntityOverview.vue?vue&type=script&lang=js"
export * from "./EntityOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__